import React, { FunctionComponent } from "react";
import {dispatchSpecialOfferHandleClick} from "@/animations/responsive/productPageTracking";
import Utils from "@/libs/Utils";

interface Props {
    title: string,
    endDate: string,
    isItemClickable: boolean,
    handleClick?: () => void,
    description: string | null,
    urlInfo: string | null,
}

export const SpecialOffer: FunctionComponent<Props> = ({
    title,
    description,
    endDate,
    urlInfo,
    isItemClickable,
    handleClick,
}) => {
    const Content = () => (
        <div className="text">
            <p className="title" dangerouslySetInnerHTML={{ __html: title }}></p>
            <div className="description">
                {description && (
                    <p dangerouslySetInnerHTML={{ __html: description }}></p>
                )}
                <p>{`Valable jusqu'au ${Utils.formatOfferDate(endDate, endDate)}`}</p>
            </div>
        </div>
    );
    
    return urlInfo ? (
        <a
            className="special-offer clickable"
            href={urlInfo}
            target="_blank "
            rel="noopener noreferrer"
            onClick={() => {
                dispatchSpecialOfferHandleClick(title, urlInfo)
            }}

        >
            <Content />
            <div className="icon">
                <img src={"/assets/images/responsive/icons/link.svg"} alt="icone ouvrir nouvelle onglet" />
            </div>
        </a>
    ) : (
        <div
            className={`special-offer ${isItemClickable ? "clickable" : ""}`}
            onClick={(event) => (isItemClickable && handleClick) && handleClick()}
        >
            <Content />
            {!!isItemClickable && (
                <div className="icon">
                    <img src={"/assets/images/responsive/icons/arrow-black.svg"} alt={"icone de flèche"} />
                </div>
            )}
        </div>
    );
};
